import { GET } from "Common/api";
import config from "lib/config";
import { MODE_FULL } from "../constants";

const API_ENDPOINTS = {
  courseStatus: "v1/user/:personalId/coursestatus/:courseId",
  tags: "v1/coursecataloguecategories/:portalSiteId/",
  search: "/v1/user/:personalId/coursesforcardview",
  programsProgress: "v1/education/program/progress/:personalId",
  adminSettings: "v1/adminsettings/:settingName",
};

const portalSiteId = config.siteId;

const buildApiUrl = (opts, categoryId = 0) => {
  const params = {
    categoryId,
    searchPhrase: opts.searchText,
    sortBy: opts.sortBy,
    portalSiteId,
    profileId: 4,
    mode: MODE_FULL,
  };
  const tagParams = opts.selectedTags.map((tag) => `tags=${tag}`).join("&");
  return `${API_ENDPOINTS.search}?${new URLSearchParams(params)}&${tagParams}`;
};

const fetchCourses = async (opts) => {
  const apiUrl = buildApiUrl(opts);
  return GET(apiUrl, {
    personalId: opts.personalId,
  });
};

const fetchProgramProgress = async (personalId) => {
  return GET(API_ENDPOINTS.programsProgress, { personalId });
};

const fetchTags = async () => {
  return GET(API_ENDPOINTS.tags, { portalSiteId });
};

const fetchMaxCoursesDisplayed = async () => {
  return GET(API_ENDPOINTS.adminSettings, {
    settingName: "noofcoursesinmycoursespanel",
  });
};

export const dataFetcherService = {
  fetchCourses,
  fetchProgramProgress,
  fetchTags,
  fetchMaxCoursesDisplayed,
};
